const signUpText = "Create a free account";
const signInText = "Sign In";
const descriptionText =
    "Comment on articles, stay in the know with our newsletters and stream more on CBC Gem.";
const titleText = "Get more with a free CBC account";

export { signUpText, signInText, descriptionText, titleText };
